import { Typography, Box } from "@mui/material";
import { motion } from "framer-motion";

interface ProjectDescriptionProps {
  projectTitle?: string;
  projectDescription?: string;
  bullets?: string[];
  techStack: string[];
  year?: string;
  role?: string;
  company?: string;
  focus?: string[];
}

export default function ProjectDescription({
  projectDescription,
  bullets,
  techStack,
  year,
  role,
  focus,
}: ProjectDescriptionProps) {
  return (
    <Box
      sx={{
        alignSelf: "center",
        justifySelf: "center",
        display: "flex",
        flexDirection: "column",
        gap: "14px",
        maxWidth: 500,
      }}
    >
      {role && (
        <Typography fontSize={14} fontWeight={600}>
          {role} {year && `| ${year}`}
        </Typography>
      )}

      {/* Short Description */}
      {projectDescription && (
        <Typography fontSize={13} lineHeight={1.7}>
          {projectDescription}
        </Typography>
      )}

      {/* Diamond Bullet Points */}
      {bullets && bullets.length > 0 && (
        <Box component="ul" sx={{ listStyle: "none", p: 0, m: 0 }}>
          {bullets.map((item, index) => (
            <Box
              component="li"
              key={index}
              sx={{
                position: "relative",
                pl: 3,
                mb: 1.5,
                lineHeight: 1.7,
                "&::before": {
                  content: '""',
                  position: "absolute",
                  left: 0,
                  top: "8px",
                  width: "6px",
                  height: "6px",
                  border: "1px solid rgba(0,0,0,0.7)",
                  transform: "rotate(45deg)",
                },
              }}
            >
              <Typography fontSize={13}>{item}</Typography>
            </Box>
          ))}
        </Box>
      )}

      {/* Tech Stack */}
      <Box display="flex" flexDirection="row" gap={2} flexWrap="wrap" mt={1}>
        {techStack.map((tech, index) => (
          <motion.div
            key={index}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.95 }}
          >
            <Typography fontSize={13}>{tech}</Typography>
          </motion.div>
        ))}
      </Box>

      {/* Focus Section */}
      {focus && focus.length > 0 && (
        <Box display="flex" flexDirection="column" gap={1} mt={2}>
          <Typography fontSize={12} fontWeight={600}>
            Focus
          </Typography>
          <Box display="flex" flexDirection="row" gap={2} flexWrap="wrap">
            {focus.map((item, index) => (
              <motion.div
                key={index}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                <Typography fontSize={12}>{item}</Typography>
              </motion.div>
            ))}
          </Box>
        </Box>
      )}
    </Box>
  );
}
